import script from "./BuyingData.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyingData.vue?vue&type=script&setup=true&lang=js"

import "./BuyingData.vue?vue&type=style&index=0&id=5122ab2d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5122ab2d"]])

export default __exports__